import {createAction, createSlice} from '@reduxjs/toolkit';
import {AUTH_SLICE_NAME} from '@jobseeker/common-core/constants';

import type {AppState, AuthState} from '@jobseeker/common-core/types';
import {HYDRATE} from 'next-redux-wrapper';

const initialState: AuthState = {
  isLoggedIn: false,
  statusType: 1,
  userId: '-1',
  isPro: false,
  obfuscatedUserId: '',
  authInfo: {},
};

const HyDrate = createAction<AppState>(HYDRATE);

const authSlice = createSlice({
  name: AUTH_SLICE_NAME,
  initialState,
  reducers: {
    set_user_loggedin: (state, action) => {
      state.isLoggedIn = true;
      state.statusType = action.payload;
    },
    set_user_info: (state, action) => {
      state.userId = action.payload.userId;
      if (action.payload.obfuscatedUserId !== undefined) {
        state.obfuscatedUserId = action.payload.obfuscatedUserId;
      }
    },
    set_auth: (state, action) => {
      state.authInfo = action.payload;
    },
    set_pro: (state, action) => {
      state.isPro = action.payload;
    },
    set_user_logged_out: (state, action) => {
      state.isLoggedIn = false;
      state.authInfo = {};
      state.userId = '-1';
      state.obfuscatedUserId = '';
    },
  },
  extraReducers(builder) {
    builder.addCase(HyDrate, (state, action) => {
      if (!action.payload?.app) {
        return state;
      }

      state.isPro = action.payload?.auth?.isPro;
      if (action.payload?.auth?.isLoggedIn) {
        state.isLoggedIn = action.payload.auth.isLoggedIn;
        state.userId = action.payload.auth.userId;
      }
    });
  },
});

export const {
  set_user_loggedin,
  set_user_info,
  set_auth,
  set_user_logged_out,
} = authSlice.actions;

const reducer = authSlice.reducer;

export {reducer, initialState};
